<template>
  <div>
    <div class="d-flex align-center">
      <h3>アルバム一覧</h3>
      <v-spacer />
      <v-btn to="/memoru/upload" class="mr-2" color="primary" variant="outlined">
        アップロード
      </v-btn>
      <v-btn @click="createAlbumDialog = true" color="primary" variant="flat">
        <v-icon start>mdi-plus</v-icon>
        アルバム作成
      </v-btn>
    </div>

    <v-card variant="flat" color="grey-lighten-5" class="mt-2">
      <v-container>
        <v-row>
          <v-col cols="3">
            <h5>年度</h5>
            <v-text-field
              v-model="searchFilters.year"
              variant="outlined"
              hide-details
              density="compact"
              :disabled="loading"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <h5>公開設定</h5>
            <v-select
              v-model="searchFilters.isPublished"
              :items="isPublishedItems"
              variant="outlined"
              hide-details
              density="compact"
              :disabled="loading"
            ></v-select>
          </v-col>
          <v-col cols="3">
            <h5>売上枚数(下限)</h5>
            <v-text-field
              v-model="searchFilters.purchaseCountMin"
              variant="outlined"
              hide-details
              density="compact"
              suffix="枚"
              :disabled="loading"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <h5>クラス</h5>
            <v-select
              v-model="searchFilters.nurseryClassIds"
              :items="classes"
              item-title="className"
              item-value="classId"
              multiple
              variant="outlined"
              hide-details
              density="compact"
              :disabled="loading"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-spacer />
          <v-col cols="4">
            <v-btn
              @click="listAlbums"
              :loading="loading"
              color="primary"
              variant="flat"
              block
              class="search-button"
              >{{ $t('memoru.search') }}</v-btn
            >
          </v-col>
          <v-spacer />
        </v-row>
      </v-container>
    </v-card>

    <div v-if="albums" class="pt-4 d-flex align-center">
      <h5>計{{ albums.total || 0 }}件</h5>
      <v-spacer />
    </div>

    <div class="pt-4">
      <v-row v-if="albums">
        <v-col cols="3" v-for="(item, i) in albums.items" :key="i">
          <memoru-album-card :album="item"></memoru-album-card>
        </v-col>
      </v-row>
      <v-pagination
        class="mt-6"
        v-if="albums"
        v-model="page"
        @update:model-value="pageClick"
        :length="Math.ceil(albums.total / searchFilters.limit)"
      >
      </v-pagination>
    </div>

    <v-form v-model="createAlbumForm">
      <v-dialog v-model="createAlbumDialog" max-width="600px" persistent>
        <v-card>
          <v-card-title> アルバム作成 </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="createAlbumInput.title"
                    :rules="[required]"
                    label="タイトル*"
                    hide-details
                    variant="outlined"
                    density="compact"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="createAlbumInput.year"
                    :rules="[required]"
                    label="年度*"
                    hide-details
                    suffix="年度"
                    variant="outlined"
                    density="compact"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-model="createAlbumInput.nurseryClassIds"
                    :items="classes"
                    item-title="className"
                    item-value="classId"
                    label="クラス"
                    hide-details
                    variant="outlined"
                    density="compact"
                    multiple
                    chips
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-if="showAvailable"
                    type="date"
                    v-model="internalDateAfter"
                    label="公開開始日*"
                    hide-details
                    clearable
                    variant="outlined"
                    density="compact"
                    @update:model-value="createCombinedDateTimeAfter"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-if="showAvailable"
                    type="time"
                    v-model="internalTimeAfter"
                    label="公開開始時*"
                    hide-details
                    clearable
                    variant="outlined"
                    density="compact"
                    @update:model-value="createCombinedDateTimeAfter"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-if="showAvailable"
                    type="date"
                    v-model="internalDateBefore"
                    label="公開終了日"
                    hide-details
                    clearable
                    variant="outlined"
                    density="compact"
                    @update:model-value="createCombinedDateTimeBefore"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-if="showAvailable"
                    type="time"
                    v-model="internalTimeBefore"
                    label="公開終了時"
                    hide-details
                    clearable
                    variant="outlined"
                    density="compact"
                    @update:model-value="createCombinedDateTimeBefore"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="createAlbumInput.comment"
                    label="コメント"
                    hide-details
                    variant="outlined"
                    density="compact"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-container>
              <v-row>
                <v-btn 
                  @click="createAlbumDialog = false" 
                  color="grey" 
                  variant="text"
                >
                  キャンセル
                </v-btn>
                <v-spacer />
                <v-btn
                  @click="createAlbum"
                  :disabled="!createAlbumForm"
                  :loading="loading"
                  color="primary"
                  variant="flat"
                >
                  作成
                </v-btn>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import MemoruAlbumCard from "@/components/atoms/MemoruAlbumCard.vue";
import { memoruModule } from "@/store/dataModules/memoruModule";
import LocalDataService from "@/service/LocalDataService";
import {
  MultimediaAlbumListResponse,
  NurseryClassResponse,
} from "chaild-api/lib";
import ApiMemoru from "@/api/ApiMemoru";
import { snackbarModule } from "@/store/viewModules/snackbarModule";
import ValidationMixin from "@/mixins/ValidationMixin";
import dayjs from "dayjs";
import { classModule } from "@/store/dataModules/classModule";
import { isPublishedItems } from "@/constants/memoru";

export default defineComponent({
  name: "MemoruAlbum",

  mixins: [ValidationMixin],

  components: {
    MemoruAlbumCard,
  },

  async mounted() {
    const memoruAlbumPage = sessionStorage.getItem('memoruAlbumPage');
    if (memoruAlbumPage) this.page = Number(memoruAlbumPage);
    await this.listAlbums();
    await this.listClasses();
  },

  computed: {
    albums: function (): MultimediaAlbumListResponse | null {
      return memoruModule.albums;
    },
    classes(): NurseryClassResponse[] {
      if (this.createAlbumInput.year) {
        return classModule.classes.filter((c) => {
          return String(c.year) == this.createAlbumInput.year;
        });
      } else {
        return classModule.classes;
      }
    },
    page: {
      get(): number {
        if (this.searchFilters.skip == 0) {
          return 1;
        }
        return Math.ceil(
          this.searchFilters.skip / (this.searchFilters.limit - 1)
        );
      },
      set(value: number) {
        this.searchFilters.skip = (value - 1) * this.searchFilters.limit;
        this.listAlbums();
      },
    },
  },

  data() {
    return {
      loading: false,
      searchFilters: {
        year: "",
        nurseryClassIds: [],
        purchaseCountMin: "",
        isPublished: undefined as boolean | undefined,
        limit: 20,
        skip: 0,
      },
      isPublishedItems: isPublishedItems,
      createAlbumDialog: false,
      createAlbumForm: false,
      createAlbumInput: {
        title: "",
        year: "",
        nurseryClassIds: [],
        comment: "",
        availableAfter: "",
        availableBefore: "" as string | null,
      },
      showAvailable: true,
      internalDateAfter: '' as string | null,
      internalTimeAfter: '00:00' as string | null,
      internalDateBefore: '' as string | null,
      internalTimeBefore: '' as string | null,
    };
  },

  watch: {
    internalDateBefore: 'createCombinedDateTimeBefore',
    internalTimeBefore: 'createCombinedDateTimeBefore',
    'createAlbumInput.availableBefore': {
      handler(newValue) {
        if (newValue) {
          const parts = newValue.split('T');
          if (parts.length === 2) {
            this.internalDateBefore = parts[0];
            this.internalTimeBefore = parts[1];
          }
        } else {
          this.internalDateBefore = '';
          this.internalTimeBefore = '';
        }
      },
      immediate: true
    },

    internalDateAfter: 'createCombinedDateTimeAfter',
    internalTimeAfter: 'createCombinedDateTimeAfter',
    'createAlbumInput.availableAfter': {
      handler(newValue) {
        if (newValue) {
          const parts = newValue.split('T');
          if (parts.length === 2) {
            this.internalDateAfter = parts[0];
            this.internalTimeAfter = parts[1];
          }
        } else {
          this.internalDateAfter = '';
          this.internalTimeAfter = '';
        }
      },
      immediate: true
    },
  },

  methods: {
    async pageClick(pageNumber: number) {
      if (pageNumber) sessionStorage.setItem('memoruAlbumPage', String(pageNumber));
    },
    createCombinedDateTimeAfter() {
      if (this.internalDateAfter) {
        const combinedDateTimeAfter = `${this.internalDateAfter}T${this.internalTimeAfter || '00:00'}`;
        this.createAlbumInput.availableAfter = combinedDateTimeAfter;
      } else {
        this.createAlbumInput.availableAfter = '';
      }
    },
    createCombinedDateTimeBefore() {
      if (this.internalDateBefore) {
        const combinedDateTimeBefore = `${this.internalDateBefore}T${this.internalTimeBefore || '00:00'}`;
        this.createAlbumInput.availableBefore = combinedDateTimeBefore;
      } else {
        this.createAlbumInput.availableBefore = '';
      }
    },
    async listAlbums() {
      this.loading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        await memoruModule.listAlbums({
          ...this.searchFilters,
          nurseryId,
        });
      }
      this.loading = false;
    },
    async createAlbum() {
      this.loading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        const response = await ApiMemoru.createAlbum({
          nurseryId,
          ...this.createAlbumInput,
        }).catch(() => (this.loading = false));
        if (response) {
          snackbarModule.snackOn({
            message: "アルバムを作成しました",
          });
          this.createAlbumDialog = false;
          await this.listAlbums();
        }

        this.internalDateAfter = null;
        this.internalTimeAfter = null;
        this.internalDateBefore = null;
        this.internalTimeBefore = null;

        this.showAvailable = false;
        this.$nextTick(() => {
          this.showAvailable = true;
        });
      }
      this.loading = false;
    },
    async listClasses() {
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        await classModule.listClass({
          nurseryId,
        });
      }
    },
  },
});
</script>